import type { QueryClient } from "@tanstack/react-query";
import type { DocumentListSnapshot } from "web_myplann/Api/Document/updateDocumentLists";

export const restoreDocumentListCache = (
	queryClient: QueryClient,
	snapshot: DocumentListSnapshot,
) => {
	for (const [queryKey, list] of snapshot) {
		queryClient.setQueryData(queryKey, list);
	}
};
